import { render, staticRenderFns } from "./UpsellCurrentListCompanies.vue?vue&type=template&id=c9ff3c34&"
import script from "./UpsellCurrentListCompanies.vue?vue&type=script&lang=js&"
export * from "./UpsellCurrentListCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports